/** Join truthy class name fragments for primitive components. */
export default function joinClassNames(...values) {
  return values.filter(Boolean).join(' ')
}
